export default __webpack_public_path__ + "static/media/CRS_7095-HDR-min.bf17e991.jpg";